import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { Api } from 'src/smoothr-web-app-core/api/api';

export enum AskToCreateAccountEnum {
	SSO_SIGN_IN_CANCEL = 'sso_sign_in_cancel',
}

@Component({
	selector: 'app-ask-to-create-account-modal',
	templateUrl: './ask-to-create-account-modal.component.html',
	styleUrls: ['./ask-to-create-account-modal.component.scss'],
})
export class AskToCreateAccountModalComponent implements OnInit {
	public askToCreateAccountEnum = AskToCreateAccountEnum;
	// public enterEmail = new FormControl('', [Validators.required, Validators.email]);
	public showLoginScreen: boolean = false;
	// public ssoToken: any = '';
	@(Input()!) name: string;

	constructor(
		private modalCtrl: ModalController,
		private router: Router,
		private route: ActivatedRoute
	) {}
	static async show(modalCtrl: ModalController): Promise<AskToCreateAccountEnum | string> {
		const modal = await modalCtrl.create({
			cssClass: 'auto-height',
			component: AskToCreateAccountModalComponent,
			componentProps: {},
			showBackdrop: true,
			backdropDismiss: false,
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			if (params && params?.name) {
				this.name = params?.name;
			}
		});
	}
	dismiss(value?: AskToCreateAccountEnum) {
		this.modalCtrl.dismiss(value);
	}
	login() {
		const OrderId = localStorage.getItem('currentOrderId');
		if (this.name) {
			window.location.href =
				environment.baseUrl +
				'/v1/customer/oauth/fra-eintracht/authorize?customerGroup=' +
				environment.customerGroup +
				'&order=' +
				OrderId +
				'&name=' +
				this.name;
			return;
		}
		window.location.href =
			environment.baseUrl +
			'/v1/customer/oauth/fra-eintracht/authorize?customerGroup=' +
			environment.customerGroup +
			'&order=' +
			OrderId;
	}
	// login() {
	// 	this.modalCtrl.dismiss('sign_in');
	// }
	// signUp() {
	// 	this.modalCtrl.dismiss('sign_up');
	// }
	// asGuest() {
	// 	this.modalCtrl.dismiss(this.enterEmail.value);
	// }
	// 	async loginWithSSO() {
	// 		this.modalCtrl.dismiss().then(async () => {
	// 			this.showLoginScreen = true;
	// 			const modalWelcome = await this.modalCtrl.create({
	// 				cssClass: 'welcome',
	// 				component: AskToCreateAccountModalComponent,
	// 				componentProps: {
	// 					showLoginScreen: this.showLoginScreen,
	// 				},
	// 				showBackdrop: true,
	// 				backdropDismiss: true,
	// 			});
	// 			await modalWelcome.present();
	// 		});
	// 		setTimeout(async() => {
	// 			//  try {
	// 			// 	this.ssoToken = await Api.getAccessTokenSSO();
	// 			// 	console.log(this.ssoToken);
	// 			// 	window.location.href = this.ssoToken.data.url;
	// 			// }catch(e){
	// 			// 	console.log(e);
	// 			// }
	// 			this.modalCtrl.dismiss({ dismissed: true, reason: 'timeout' }).then(() => {
	// 				const OrderId = localStorage.getItem('currentOrderId');
	// 				console.log('REDIRECTING TO SSO WITH ORDER ID', OrderId);
	// 				// const verifiedOrder = JSON.parse(localStorage.getItem('repository-service-verified-order')) || '';
	// 				window.location.href = environment.baseUrl + '/v1/customer/oauth/fra-eintracht/authorize?customerGroup=' + environment.customerGroup + '&order=' + OrderId;
	// 				// window.location.assign(environment.baseUrl + '/v1/customer/oauth/fra-eintracht/authorize?customerGroup=' + environment.customerGroup);
	// 				// this.router.navigate([environment.baseUrl + '/v1/customer/oauth/fra-eintracht/authorize', { queryParams: { customerGroup: environment.customerGroup } }]);
	// 			})
	// 		}, 5000);
	// 	}
}
